<template>
  <div class="loading-wrapper">
    <slot />
    <ins class="loading-bounce">
      <div class="double-bounce1"></div>
      <div class="double-bounce2"></div>
    </ins>
  </div>
</template>

<script>
  export default {
    name: 'Loading',
  }
</script>

<style lang="scss">
  .loading-wrapper .progressbar {
    display: none;
    @media (min-width: $min-sm) {
      display: inline-block;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: $default-bg;
      width: 600px;
      margin: 0 auto;
      @include panel-shadow();
      padding: 10px;
      +.loading-bounce {
        display: none;
      }
      .loading-bounce {
        margin: 10px;
      }
    }
  }
  .loading-bounce {
    width: 70px;
    height: 70px;
    display: inline-block;
    position: relative;
    margin: 100px auto;
    .double-bounce1, .double-bounce2 {
      width: 100%;
      height: 100%;
      background-color: white;
      @include panel-shadow;
      opacity: 0.6;
      position: absolute;
      top: 0;
      left: 0;
      animation: sk-bounce 1.2s infinite ease-in-out;
    }
    .double-bounce2 {
      animation-delay: -0.6s;
    }
  }
  .loading-wrapper {
    text-align: center;
    flex-grow: 1;
    &.compact {
      .loading-bounce {
        margin: 10px auto;
      }
    }
    &.absolute {
      position: absolute;
      background: rgba($body-bg, .5);
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      > span:first-child {
        position: absolute;
        margin: 0;
        top: calc(50% - 70px);
        left: 50%;
        transform: translate(-50%, -50%);
        display: inline-block;
        padding: 10px;
        background-color: white;
        @include panel-shadow;
      }
      > .loading-bounce {
        position: absolute;
        margin: 0;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  @keyframes sk-bounce {
    0%, 100% {
      transform: scale(0.2);
      opacity: .2;
    } 50% {
      transform: scale(1.0);
      opacity: .8;
    }
}
</style>



// WEBPACK FOOTER //
// src/helpers/components/interact/Loading.vue